import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaUserCheck,
  FaIdCard,
  FaExternalLinkAlt,
  FaListAlt,
  FaCheckCircle,
  FaFileUpload,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";

const DcbBank = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };

  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }

  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  const currentCards = CreditCardData.cards
    ?.filter((card) => card.title?.toLowerCase().includes("dcb bank"))
    .slice(indexOfFirstCard, indexOfLastCard);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const faqs = [
    {
      question: "Does DCB Bank offer credit cards with reward programs?",
      answer:
        "Yes. DCB Bank credit cards typically include reward point programs for fuel, dining, retail, and utility spends.",
    },
    {
      question:
        "How long does DCB Bank take to approve a credit card application?",
      answer:
        "The typical turnaround time for approval and dispatch is 7–10 working days, depending on document verification.",
    },
    {
      question: "Can I apply for a DCB credit card if I am self-employed?",
      answer:
        "Yes. Self-employed individuals with valid financial records and income proof are eligible for DCB credit cards.",
    },
    {
      question: "Are DCB Bank credit cards accepted internationally?",
      answer:
        "Yes. Most DCB credit cards are internationally accepted and come with secure chip-and-PIN features for global usage.",
    },
    {
      question: "Is there a mobile app to manage my DCB credit card?",
      answer:
        "Yes. You can use the DCB Mobile Banking App to track transactions, pay bills, set card limits, and access reward balances.",
    },
  ];

  const steps = [
    {
        icon: <FaCheckCircle className="h-6 w-6 text-orange-500" />,
        title: "Check Your Eligibility",
        description:
          "Read the eligibility criteria listed for your chosen card and ensure that you meet the income, age, and credit score requirements.",
      },
      {
        icon: <FaFileUpload className="h-6 w-6 text-green-500" />,
        title: "Gather Required Documents",
        description:
          "Keep your KYC and income documents ready for submission, as outlined in the application prerequisites.",
      },
      {
        icon: <FaExternalLinkAlt className="h-6 w-6 text-purple-600" />,
        title: "Apply via Official DCB Bank Portal",
        description:
          "Click “Apply Now” on TheFinMaster, and you’ll be redirected to the official DCB Bank website, where you can safely complete your credit card application.",
      },
    {
      icon: <FaListAlt className="h-6 w-6 text-teal-500" />,
      title: "Explore & Compare with TheFinMaster",
      description:
        "Start by browsing through our expertly curated list of DCB Bank credit cards at TheFinMaster. Get insights into fees, features, benefits, and who the card is best suited for—so you can make an informed choice before applying.",
    },
   
  ];

  return (
    <>
      <Helmet>
        <title>
          Get DCB Bank Credit Card 2024 - Compare & Apply Online at TheFinmaster
        </title>
        <meta
          name="description"
          content="DCB Bank Credit Cards - Check all types of DCB Bank credit cards list & their benefits to select the right card for you. Apply for top & best DCB credit card now. | TheFinmaster"
        />
        <meta
          name="keywords"
          content="dcb bank credit card, dcb credit card apply, dcb bank credit card benefits, dcb credit card eligibility, dcb bank credit card rewards"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/dcb-bank/credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex flex-col items-center ">
        <div className="w-full flex flex-col items-center ">
          <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
            <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
              Credit Card
            </h1>
            <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
              Experience financial freedom and flexibility with our credit card
              options.
            </p>
          </div>
        </div>
        <div className="flex justify-center items-center  p-4 mt-10">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              Smart, Secure & Tailored for Modern Users
            </h2>

            <p className="text-gray-600 leading-relaxed mt-3">
              DCB Bank offers a select range of credit cards designed for
              discerning users who value smart spending, digital convenience, and
              personalized rewards. With a strong presence in the retail and SME
              banking space, DCB ensures that its credit card offerings are not
              only secure and efficient but also tailored for everyday utility
              and lifestyle benefits. From cashback and EMI options to contactless
              transactions and reward points, DCB credit cards aim to simplify
              your financial journey.
            </p>
          </div>
        </div>
        <h1 className="text-center text-3xl font-bold text-gray-800 my-10">
          Featured Credit Cards
        </h1>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                     key={index}
                     cardDetails={item}
                     Card_features={item?.Card_features}
                     fees={item?.fees}
                     cardName={item?.title}
                     cardImage={item?.image}
                     rating={item?.rating}
                     category={item?.category}
                     status={item?.status}
                     bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

          <div className="w-full relative ">
                              <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
                                {/* <div className="w-[70%] mx-auto">
                                                           <h2 className="text-center font-medium pt-5 text-lg">
                                                             <span className="font-semibold text-white">816 people</span>{" "}
                                                             are on call with our advisors right now
                                                           </h2>
                                                         </div> */}
                                <div className="w-full mx-auto">
                                  <Link
                                    to="https://play.google.com/store/apps/details?id=com.popclub.android&pcampaignid=web_share"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <div className="w-[80%] mx-auto ">
                                      <img src="/assets/ppp.png" alt="Advertisement" />
                                    </div>
                                  </Link>
                                  <div className="bg-white">
                                    {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                               Know your advisor
                                                             </h3> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

     

        <div className="w-full px-2 py-10 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-3xl font-bold text-gray-800 dark:text-white">
                  Eligibility Criteria to Apply for DCB Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Age Limit
                  </span>
                  <span>
                    The applicant should be 21 to 60 years old. Add-on cardholders
                    must be at least 18 years of age at the time of application.
                  </span>
                </div>

                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Monthly Income
                  </span>
                  <span>
                    A minimum monthly salary of ₹25,000–₹30,000 is generally
                    preferred. For self-employed applicants, DCB assesses stable
                    annual income through ITRs or bank statements.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Credit Score Benchmark
                  </span>
                  <span>
                    A CIBIL score of 700 or above is recommended. DCB Bank
                    prioritizes applicants with a clean credit history and no
                    recent defaults.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Employment Status
                  </span>
                  <span>
                    Both salaried professionals and self-employed individuals are
                    eligible, subject to income proof and financial health
                    validation.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Banking Relationship with DCB (Optional)
                  </span>
                  <span>
                    While not mandatory, existing DCB Bank customers may enjoy a
                    simplified application process and faster approval for credit
                    cards.
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-3xl font-bold text-gray-800 dark:text-white">
                  Documents Required to Apply for DCB Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Identity
                  </span>
                  <span>
                    Government-issued IDs like Aadhaar Card, PAN Card, Driving
                    License, or Passport are accepted as valid ID proof.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Address
                  </span>
                  <span>
                    Valid documents include utility bills, Aadhaar, passport, or
                    rental agreements issued within the last 3 months.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Income
                  </span>
                  <span>
                    Salaried: Last 3 months' salary slips or Form 16.
                    Self-employed: Latest ITR filings, audited balance sheets, or
                    bank statements.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    PAN Card
                  </span>
                  <span>
                    Mandatory for identity verification, tax compliance, and to
                    proceed with KYC checks under RBI norms.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Recent Passport-Size Photograph
                  </span>
                  <span>
                    Required for application processing and card issuance
                    formalities.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          How to Apply for DCB Bank Credit Card
        </h2>
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default DcbBank;